// extracted by mini-css-extract-plugin
export var dismissOverlay = "_ho-b";
export var interactivePassthrough = "_ho-3";
export var modal = "_ho-d";
export var modalBackdrop = "_ho-c";
export var modalBody = "_ho-j";
export var modalDescription = "_ho-m";
export var modalEnter = "_ho-e";
export var modalFooter = "_ho-n";
export var modalHeaderText = "_ho-h";
export var modalIconCircle = "_ho-i";
export var modalIconHeader = "_ho-g";
export var modalImage = "_ho-f";
export var modalSectionLabel = "_ho-k";
export var modalTitle = "_ho-l";
export var pulse = "_ho-1";
export var pulseBorder = "_ho-2";
export var spotlight = "_ho-0";
export var tooltip = "_ho-4";
export var tooltipButtons = "_ho-9";
export var tooltipDescription = "_ho-6";
export var tooltipFooter = "_ho-7";
export var tooltipInteractivePill = "_ho-a";
export var tooltipStepIndicator = "_ho-8";
export var tooltipTitle = "_ho-5";